import React, { Component } from 'react';
import Button from '../../CustomButton';
import './index.css';

class HeaderSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewport: {
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight
      }
    }
    this._resize_mixin_callback = this._resize_mixin_callback.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(){
    window.location.href = window.location.origin + '/home/#';
  }

  componentDidMount() {
    window.addEventListener('resize', this._resize_mixin_callback);
  }

  _resize_mixin_callback() {
    this.setState({
      viewport: {
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight
      }
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._resize_mixin_callback);
  }


  getResponsiveStyle(){
    const { viewport } = this.state;
    const { lang } = this.props;
    if (viewport.width < 951) {
      return {
        textSectionWrapper:{ textAlign: 'center', width: '96%', justifyContent:'center' },
        buttonSection:{ justifyContent: 'space-around' }
      };
    }
    else {
      return {
        textSectionWrapper:{ textAlign: lang === 'fa' ? 'right' : 'left', width: lang === 'fa' ? '36%' : '40%' },
        buttonSection:{ justifyContent: lang === 'fa' ? 'flex-end' : 'flex-start' }
      };
    }
  }

  render() {
    const { lang } = this.props;
    const responsiveStyle = this.getResponsiveStyle();
    return (
      <div className='desc-sa'>
        <div className='desc-sa-ls-unlay'></div>
        <div className='desc-sa-wrapper'>
          <div className='desc-sa-text-section'>
            <div style={responsiveStyle.textSectionWrapper} className='desc-sa-ts-wrapper'>
              <div className='desc-sa-ts-description'>
                <h1>{lang === 'fa' ? 'سامانه جامع تحلیل بنیادی' : 'The Financial Data Platform of IRAN Markets'}</h1>
                <p style={{ direction: lang === 'fa' ? 'rtl' : 'ltr' }}>
                  {lang === 'fa' ? 'سامانه جامع تحلیل بنیادی بورس ویو، با انتشار در لحظه صورتهای مالی و اطلاعیه‌ها و گزارش های تفسیری شرکتها در فرمت مورد نیاز تحلیلگران ضمن بی نیاز کردن از سامانه کدال، نسبتها و ضرایب مالی را با بالاترین دقت محاسبه کرده و قابلیت مقایسه و گزارشگیری متنوعی را در اختیار می دهد. '
                    : 'If you looking for investment opportunities in Iran, you have all the tools and data you need to find the right opportunities that fulfills your investment goals. '
                  }
                </p>
                <div className='desc-sa-ts-description-wrapper'>
                  <ul>
                    <li style={{ direction: lang === 'fa' ? 'ltr' : 'rtl' }}>
                      <span style={{ marginRight: lang === 'fa' ? '20px' : '0', marginLeft: lang === 'en' ? '20px' : '0' }}>
                        {lang === 'fa' ? 'بدون نیاز به نصب و راه اندازی' : 'No Installation'}
                      </span>
                      <div className='bg-yellow'><img alt='' src={require('../../../../assets/images/instalation.svg')} /></div>
                    </li>
                    <li style={{ direction: lang === 'fa' ? 'ltr' : 'rtl' }}>
                      <span style={{ marginRight: lang === 'fa' ? '20px' : '0', marginLeft: lang === 'en' ? '20px' : '0' }}>
                        {lang === 'fa' ? 'رابط کاربری ساده و آسان' : 'No clunky interfaces'}
                      </span>
                      <div className='bg-red'><img alt='' src={require('../../../../assets/images/clipboard.svg')} /></div>
                    </li>
                    <li style={{ direction: lang === 'fa' ? 'ltr' : 'rtl' }}>
                      <span style={{ marginRight: lang === 'fa' ? '20px' : '0', marginLeft: lang === 'en' ? '20px' : '0' }}>
                        {lang === 'fa' ? 'نسخه فارسی و انگلیسی' : 'No Limitation'}
                      </span>
                      <div className='bg-pink'><img alt='' src={require('../../../../assets/images/language.svg')} /></div>
                    </li>
                  </ul>
                  <div style={responsiveStyle.buttonSection} className='desc-sa-ts-button-section'>
                    <Button className='desc-sa-ts-bs-button-a' onClick={this.handleClick}>
                      {lang === 'fa' ? 'ورود به برنامه' : 'Sign In'}
                    </Button>
                    {/* <Button className='desc-sa-ts-bs-button-b'>
                      {lang === 'fa' ? 'راهنمای استفاده' : 'View Documentation'}
                    </Button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='desc-sa-ts-img-section'>
            <div className='desc-sa-ts-img-top-unlay'></div>
            <img className='desc-sa-ts-is-img' alt='' src={require("../../../../assets/images/pic-ht17.jpg")} />
            <div className='desc-sa-ts-is-img-shadow'></div>
            <div className='desc-sa-ts-is-img-bottom-unlay'> 
              <div className='desc-sa-ts-is-img-inner-unlay'></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



export default HeaderSection;
